module.exports = __webpack_public_path__ + "img/tap.df9c5eb4.svg";